import { useContext } from "react";
import { FormContext } from "view/components/Form";
import { FieldValues, UseFormReturn } from "react-hook-form";

export const useFormContext = <T extends FieldValues>() => {
  return useContext(FormContext) as UseFormReturn<T>;
};
